import { motion } from "framer-motion";

const CHAPTERS = [
    { num: "I", text: "Think differently." },
    { num: "II", text: "Market differently." },
    { num: "III", text: "Create differently." },
    { num: "IV", text: "Make money differently." },
];

export const Manifesto = () => (
    <section id="manifesto" data-testid="manifesto-section" className="relative py-24 sm:py-32 lg:py-40 bg-[#0E0818] border-y border-orchid/20 overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_50%,rgba(139,92,246,0.16),transparent_60%)] pointer-events-none" />
        <div className="absolute -top-24 -right-24 w-[40vw] h-[40vw] rounded-full bg-magenta/15 blur-[110px] pointer-events-none" />
        <div className="relative max-w-5xl mx-auto px-5 sm:px-8 lg:px-16 text-center">
            <motion.p
                initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true, margin: "-100px" }} transition={{ duration: 1 }}
                className="font-mono text-[11px] sm:text-xs tracking-[0.35em] uppercase text-gold mb-12"
            >
                The Core Message
            </motion.p>
            <motion.blockquote
                data-testid="manifesto-quote"
                initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-100px" }} transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
                className="font-serif italic text-2xl sm:text-4xl lg:text-5xl leading-snug text-white"
            >
                "The future belongs to people who know how to combine{" "}
                <span className="gold-text not-italic font-semibold">human creativity</span> with{" "}
                <span className="violet-text not-italic font-semibold">artificial intelligence</span>."
            </motion.blockquote>

            <div className="mt-20 grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10">
                {CHAPTERS.map((ch, i) => (
                    <motion.div
                        key={ch.num}
                        data-testid={`manifesto-chapter-${i + 1}`}
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-60px" }}
                        transition={{ duration: 0.7, delay: i * 0.12 }}
                        className="bg-[#0E0818] px-4 py-10 sm:py-14 group hover:bg-[#1D1038] transition-colors duration-500"
                    >
                        <span className="block font-serif italic text-gold/60 text-xl mb-4 group-hover:text-gold transition-colors duration-500">{ch.num}.</span>
                        <span className="block font-sans font-light tracking-wide text-sm sm:text-base text-zinc-300">{ch.text}</span>
                    </motion.div>
                ))}
            </div>

            <motion.div
                initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ duration: 1, delay: 0.4 }}
                className="mt-16 flex items-center justify-center gap-4"
            >
                <img
                    src="/toriano-profile.webp"
                    alt="Toriano Sanzone"
                    data-testid="manifesto-author-portrait"
                    className="w-14 h-14 rounded-full object-cover border border-gold/50 shadow-[0_0_30px_rgba(168,85,247,0.35)]"
                />
                <p className="font-serif italic text-gold/70 text-lg tracking-[0.2em]">— Toriano Sanzone</p>
            </motion.div>
        </div>
    </section>
);
